const actions = {
  SET_STATE: 'jobs/SET_STATE',
  SET_JOBS_CREATOR: 'jobs/SET_JOBS_CREATOR',
}

export default actions
